import { CONTENT_TYPES } from '@core/constants/contentTypes.constants';

/**
 * Object containing revalidation tags used to revalidate the content with Next.js
 */
export const REVALIDATION_TAGS = {
  ACCORDION_BLOCK: CONTENT_TYPES.ACCORDION_BLOCK,
  ACCORDION_SECTION: CONTENT_TYPES.ACCORDION_SECTION,
  ARTICLE: CONTENT_TYPES.ARTICLE_PAGE,
  ARTICLE_PROMO_BLOCK: CONTENT_TYPES.ARTICLE_PROMO_BLOCK,
  CATEGORY: CONTENT_TYPES.CATEGORY_TAG,
  CLUB: CONTENT_TYPES.CLUB_TAG,
  COMPETITION: CONTENT_TYPES.COMPETITION,
  CONTENT_SCROLLER_BLOCK: CONTENT_TYPES.CONTENT_SCROLLER_BLOCK,
  DICTIONARY_KEY: CONTENT_TYPES.DICTIONARY_KEY_TAG,
  DOWNLOAD_BLOCK: CONTENT_TYPES.DOWNLOAD_BLOCK,
  EMBED_BLOCK: CONTENT_TYPES.EMBED_BLOCK,
  FIXTURE: CONTENT_TYPES.FIXTURE_TAG,
  FIXTURES_SUMMARY_BLOCK: CONTENT_TYPES.FIXTURES_SUMMARY_BLOCK,
  FOOTER_BLOCK: CONTENT_TYPES.FOOTER_BLOCK,
  GATEWAY_CAROUSEL_BLOCK: CONTENT_TYPES.GATEWAY_CAROUSEL_BLOCK,
  GLOBAL_SETTINGS: CONTENT_TYPES.GLOBAL_SETTINGS,
  HEADER_BLOCK: CONTENT_TYPES.HEADER_BLOCK,
  HEADER_HERO_BLOCK: CONTENT_TYPES.HEADER_HERO_BLOCK,
  IN_PAGE_HEADER_NAVIGATION: CONTENT_TYPES.IN_PAGE_HEADER_NAVIGATION,
  ITEM_NAVIGATION: CONTENT_TYPES.ITEM_NAVIGATION,
  NAVIGATION: CONTENT_TYPES.NAVIGATION,
  NEWS_CAROUSEL_BLOCK: CONTENT_TYPES.NEWS_CAROUSEL_BLOCK,
  NEWS_CATEGORY: 'NEWS_CATEGORY',
  NEWS_LISTING_PAGE: CONTENT_TYPES.NEWS_LISTING_PAGE,
  NEWS_TAG: 'NEWS_TAG',
  PROFILE: CONTENT_TYPES.PROFILE,
  PROMO_BLOCK: CONTENT_TYPES.PROMO_BLOCK,
  PROMO_CAROUSEL_BLOCK: CONTENT_TYPES.PROMO_CAROUSEL_BLOCK,
  SEASON: CONTENT_TYPES.SEASON,
  SITE_SETTINGS: CONTENT_TYPES.SITE_SETTINGS,
  STATS_BLOCK: CONTENT_TYPES.STATS_BLOCK,
  TABBED_CAROUSEL_BLOCK: CONTENT_TYPES.TABBED_CAROUSEL_BLOCK,
  TEAM: CONTENT_TYPES.TEAM,
  TEXT_BLOCK: CONTENT_TYPES.TEXT_BLOCK,
  TEXT_WITH_IMAGE_BLOCK: CONTENT_TYPES.TEXT_WITH_IMAGE_BLOCK,
  TABLE_BLOCK: CONTENT_TYPES.TABLE_BLOCK,
  PULL_QUOTE_EMBED: CONTENT_TYPES.PULL_QUOTE_EMBED,
  HERO_SLIDE: CONTENT_TYPES.HERO_SLIDE,
  GALLERY: CONTENT_TYPES.GALLERY_TAG,
  GALLERY_ARTICLE_PAGE: CONTENT_TYPES.GALLERY_ARTICLE_PAGE,
  SPONSOR_GROUP: CONTENT_TYPES.SPONSOR_GROUP_TAG,
  FIXTURE_LISTING_PAGE: CONTENT_TYPES.FIXTURE_LISTING_PAGE,
  VIDEO_CAROUSEL: CONTENT_TYPES.VIDEO_CAROUSEL,
  VIDEO: CONTENT_TYPES.VIDEO,
  VIDEO_LANDING_PAGE: CONTENT_TYPES.VIDEO_LANDING_PAGE,
  SCRIPT_EMBED: CONTENT_TYPES.SCRIPT_EMBED,
  AD_SLOT: CONTENT_TYPES.AD_SLOT,
  SOCIAL_EMBED: CONTENT_TYPES.SOCIAL_EMBED,
  ASSET_TAG: CONTENT_TYPES.ASSET_TAG,
  IMAGE_TAG: CONTENT_TYPES.IMAGE_TAG,
  LINK_TAG: CONTENT_TYPES.LINK_TAG,
  IMAGE_LINK_TAG: CONTENT_TYPES.IMAGE_LINK_TAG,
  THEME: CONTENT_TYPES.THEME,
  CONTENT_PAGE: CONTENT_TYPES.CONTENT_PAGE,
  ARTICLE_PAGE: CONTENT_TYPES.ARTICLE_PAGE,
  HOME_PAGE: CONTENT_TYPES.HOME_PAGE,
  TEAM_PAGE: CONTENT_TYPES.TEAM_PAGE,
  PROFILE_PAGE: CONTENT_TYPES.PROFILE_PAGE,
  PACKAGE_PAGE: CONTENT_TYPES.PACKAGE_PAGE,
  VIDEO_ARTICLE_PAGE: CONTENT_TYPES.VIDEO_ARTICLE_PAGE,
};
